export const shouldReplayVideo = (
  completedPlayCount: number,
  maxPlayCount?: number
) =>
  typeof maxPlayCount === "number" &&
  completedPlayCount < Math.max(1, Math.floor(maxPlayCount))
